"use client";
import React from "react";
import { AlertTriangle, AlertCircle, Info, CheckCircle } from "lucide-react";

type Props = {
  variant?: "info" | "error" | "success" | "warning";
  children: React.ReactNode;
  className?: string;
  withIcon?: boolean;
};

export default function InlineBanner({ variant = "info", children, className = "", withIcon = true }: Props) {
  // Map variants to brand tokens
  const cls =
    variant === "error"
      ? "bg-destructive/10 border border-destructive/30 text-destructive-foreground"
      : variant === "success"
      ? "bg-[color-mix(in_oklab,hsl(var(--success))_12%,transparent)] border border-[color-mix(in_oklab,hsl(var(--success))_35%,transparent)] text-[hsl(var(--success))]"
      : variant === "warning"
      ? "bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-300"
      : "bg-primary/10 border border-primary/30 text-primary";
  const role = variant === "error" ? "alert" : "status";

  const Icon = variant === "warning" ? AlertTriangle : variant === "error" ? AlertCircle : variant === "success" ? CheckCircle : Info;

  return (
    <div className={`${cls} rounded px-3 py-2 text-sm ${className}`} role={role} aria-live="polite">
      <div className="flex items-start gap-2">
        {withIcon && <Icon className="h-4 w-4 mt-0.5" aria-hidden />}
        <div>{children}</div>
      </div>
    </div>
  );
}
